import { jsx as _jsx } from "react/jsx-runtime";
import { Routing } from '../pages';
import { withProviders } from './providers';
import './styles/index.scss';
const App = () => _jsx(Routing, {});
export default withProviders(App);
